import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const ADMIN_BASE = `${BACKEND_URL}/api/admin`;
const TOKEN_KEY = "phx_admin_token";
const EXP_KEY = "phx_admin_token_exp";

export const adminAuth = {
  setSession({ token, expires_at }) {
    localStorage.setItem(TOKEN_KEY, token);
    localStorage.setItem(EXP_KEY, expires_at);
  },
  getToken() {
    const token = localStorage.getItem(TOKEN_KEY);
    const exp = localStorage.getItem(EXP_KEY);
    if (!token || !exp) return null;
    if (Date.parse(exp) <= Date.now()) {
      localStorage.removeItem(TOKEN_KEY);
      localStorage.removeItem(EXP_KEY);
      return null;
    }
    return token;
  },
  getExpiresAt() {
    return localStorage.getItem(EXP_KEY);
  },
  clear() {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(EXP_KEY);
  },
};

function authHeaders() {
  const t = adminAuth.getToken();
  return t ? { Authorization: `Bearer ${t}` } : {};
}

export async function adminLogin(password) {
  const { data } = await axios.post(`${ADMIN_BASE}/login`, { password });
  adminAuth.setSession(data);
  return data;
}

export async function adminFetch(path) {
  const { data } = await axios.get(`${ADMIN_BASE}${path}`, { headers: authHeaders() });
  return data;
}

export function adminCsvDownloadUrl(path) {
  // CSV endpoints still require Authorization header. Use fetch + Blob to avoid leaking token in URL.
  return path;
}

export async function adminDownloadCsv(path, filename) {
  const res = await fetch(`${ADMIN_BASE}${path}`, { headers: authHeaders() });
  if (!res.ok) {
    if (res.status === 401) {
      adminAuth.clear();
      throw new Error("Session expired. Please log in again.");
    }
    throw new Error(`Download failed (${res.status})`);
  }
  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => d.msg || JSON.stringify(d)).join(" ");
  return err?.message || "Something went wrong.";
}
